import React from "react";

const ImportSiteIcon = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M1.9994 0.667969H10.2754L13.9994 4.39197V15.3346H7.9994V14.0013H12.6661V6.0013H8.66606V2.0013H3.33273V8.66797H1.9994V0.667969ZM9.9994 2.2773V4.66797H12.3901L9.9994 2.2773ZM4.6994 9.3933L7.93806 12.6693L4.6994 15.9453L3.7514 15.008L5.40473 13.336H0.664062V12.0026H5.40406L3.75073 10.3306L4.6994 9.3933Z"
        fill="white"
      />
    </svg>
  );
};

export default ImportSiteIcon;
